module.exports = __webpack_public_path__ + "img/1041736696.9d8dd2db.jpg";